import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const SERVICE_AREA: [number, number][] = [
  [-35.91, 174.43],
  [-35.91, 174.55],
  [-36.05, 174.62],
  [-36.18, 174.70],
  [-36.30, 174.82],
  [-36.45, 174.82],
  [-36.59, 174.71],
  [-36.59, 174.62],
  [-36.40, 174.55],
  [-36.20, 174.45],
];

export default function ServiceAreaMap() {
  const containerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<L.Map | null>(null);

  useEffect(() => {
    if (!containerRef.current || mapRef.current) return;

    const map = L.map(containerRef.current, {
      center: [-36.25, 174.62],
      zoom: 9,
      scrollWheelZoom: false,
      zoomControl: true,
    });
    mapRef.current = map;

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 18,
    }).addTo(map);

    L.polygon(SERVICE_AREA, {
      color: "#dc2626",
      weight: 3,
      dashArray: "8 8",
      fillColor: "#dc2626",
      fillOpacity: 0.08,
    }).addTo(map);

    map.fitBounds(SERVICE_AREA, { padding: [40, 40] });

    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="h-[560px] w-full"
      aria-label="Cool Wave service area — Waipu down to Matakana, east of State Highway 1"
    />
  );
}
